import { ref, watch, computed, onMounted } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useInvoiceTemplatesList() {

    const toast = useToast()

    const refInvoiceTemplateListTable = ref(null)

    const tableColumns = [
        { key: 'id', label: '編號', sortable: true },
        { key: 'name', label: '模版名稱' },
        // { key: 'amount', label: '合約內容', sortable: true },
        { key: 'sort_order', label: '排序', sortable: true },
        { key: 'is_active', label: '狀態', sortable: true },
        { key: 'action', label: '操作' },
    ]

    const perPage = ref(10)
    const totalRow = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(false)


    const dataMeta = computed(() => {
        const localItemsCount = refInvoiceTemplateListTable.value ? refInvoiceTemplateListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalRow.value,
        }
    })

    const showMessage = (title, text, icon, variant) => {
        toast({
            component: ToastificationContent,
            props: {
                title,
                text,
                icon,
                variant
            },
        })
    }

    const refetchData = () => {
        refInvoiceTemplateListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })


    const templateList = ref(null)

    const fetchInvoiceTemplates = (ctx, callback) => {
        
        store.dispatch('invoice-template/fetchInvoiceTemplates', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
            .then(response => {
                const { invoice_templates, total } = response.data
                callback(invoice_templates)
                templateList.value = invoice_templates
                totalRow.value = total
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error fetching invoice templates list',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    return {
        fetchInvoiceTemplates,
        tableColumns,
        perPage,
        currentPage,
        totalRow,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refetchData,
        refInvoiceTemplateListTable,
        showMessage,
        templateList,
        ability
    }

}